<template>
  <v-list-group v-model="open" no-action>
    <template v-slot:activator>
      <v-list-item-icon>
        <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title
          class="menu-item"
          v-text="item.title"
        ></v-list-item-title>
      </v-list-item-content>
    </template>
    <v-list-item
      :data-test-menu="subitem.name"
      v-for="subitem in filteredList"
      :key="subitem.id"
      class="submenu_item"
      :to="{ name: routeName, params: { groupId: subitem.id } }"
    >
      <v-list-item-content>
        <v-list-item-title class="menu-item">
          {{ subitem.name }}
        </v-list-item-title>
      </v-list-item-content>

      <div class="submenu_actions">
        <v-list-item-action class="mr-0 ml-0">
          <v-btn
            :data-test-menu-action="subitem.name"
            icon
            x-small
            @click.prevent="edit(subitem)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-list-item-action>
      </div>
    </v-list-item>
    <v-list-item style="padding-left: 8px;" @click="showPopup = true">
      <v-list-item-icon>
        <v-icon>mdi-plus</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="menu-item" @click="edit({})"
          >Add groups</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
    <popup2 v-model="showPopup" @close="editedItem = {}" width="428">
      <edit
        v-if="showPopup"
        :group="editedItem"
        :show="showPopup"
        @close="
          showPopup = null;
          editedItem = {};
        "
        @remove="removeGroup"
        @apply="updateGroups"
      />
    </popup2>
  </v-list-group>
</template>

<script>
import useUsers from '@/api/users';
import { ref, onMounted, computed } from '@vue/composition-api';
export default {
  name: 'AsyncMenuItem',
  components: {
    edit: () => import('./edit')
  },
  props: {
    level: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { root }) {
    const open = ref(false);
    const showPopup = ref(false);
    const routeName = ref(null);
    const api = ref(null);
    const list = ref([]);
    const editedItem = ref({});

    const filteredList = computed(() => {
      return list.value.filter(item => !item.isSystem);
    });

    switch (props.item.data) {
      case 'users':
        api.value = useUsers().groups.load;
        routeName.value = 'users';
        break;
    }

    onMounted(() => {
      if (api.value) {
        editedItem.value = {};
        api.value().then(r => {
          list.value = r;
        });
      }
    });

    function edit(item) {
      showPopup.value = true;
      editedItem.value = item;
    }

    function updateGroups() {
      api.value().then(r => {
        list.value = r;
      });
      showPopup.value = false;
    }

    function removeGroup(id) {
      list.value = list.value.filter(i => i.id !== id);
      showPopup.value = false;
    }

    return {
      list,
      open,
      edit,
      updateGroups,
      showPopup,
      routeName,
      editedItem,
      removeGroup,
      filteredList
    };
  }
};
</script>

<style lang="scss" scoped>
.submenu_actions {
  display: none;
  position: absolute;
  top: 0;
  right: 10px;
}
.submenu_item:hover .submenu_actions {
  display: block;
}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled).highlighted {
  color: #2780e3 !important;
}
</style>
